import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import * as Yup from 'yup'
import { useFormik } from 'formik';

import { routes } from 'utils';
import { _Object } from 'utils/interfaces';
import { supplierService } from 'services';
import { Breadcrumbs, Button, InputField, LinkButton, SelectField, TextArea } from 'views/components';
// import { AsyncSelectField } from 'views/components/form-inputs';
import { countries } from 'utils/countries';
import { t } from 'i18next';


const CreateSupplier = () => {
  // const selectAsyncSelect: any = useRef([])

  const { id } = useParams()
  const navigate = useNavigate()

  const [loading, setLoading] = useState<_Object>(
    {
      listing: false,
      edit: false,
      update: false
    });
  // const [brands, setBrands] = useState<_Object>([])
  const [isEditMode, setEditMode] = useState(false)
  const [initialData, setInitialData] = useState<_Object>({
    name: '',
    company_name: '',
    email: null,
    mobile_number: null,
    status: '',
    address1: '',
    address2: '',
    city: '',
    province: '',
    country: 'IN',
    postcode: '',
    // brand_ids: [],
    description: '',
  })

  useEffect(() => {
    setEditMode(false)
    if (id) {
      setLoading({ edit: true })
      setEditMode(true)
      supplierService.getSupplierDetails(id).then((data: _Object) => {
        setInitialData({ ...data, brand_ids: data.brand_list?.map((item: _Object) => item.id) });
        setLoading({ edit: false })
      })
    }
    // brandService.getBrands('').then((data: _Object) => {
    //   setBrands(data.items)
    // })
  }, [id])

  const formik = useFormik({
    initialValues: initialData,
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().label('Name').required(t('supplier.name_required')),
      status: Yup.string().label('Status').required(t('supplier.status_required')),
    }),

    onSubmit: (values) => {

      setLoading({ update: true });
      if (id) {
        delete values.id,
          delete values.created_at
        delete values.updated_at
        delete values.brand
        delete values.client_id

        supplierService.updateSupplier(id, values).then((data: _Object) => {
          setLoading({ update: true, listing: true })
          if (data.error === false) {
            navigate(`${routes.suppilers}`)
          } else {
            setLoading({ update: false, listing: false });
            throw new Error(data.error);
          }
        }).catch((error) => {
          error && setLoading({ update: false, listing: false });
        })
      } else {
        // values.phone_number = values.phone_number.toString()
        values.province = values.province.toString()

        // delete values.note
        supplierService.createSupplier(values).then((data: _Object) => {
          setLoading({ update: true, listing: true })
          if (data.error === false) {
            navigate(`${routes.suppilers}`)
          } else {
            setLoading({ update: false, listing: false });
            throw new Error(data.error);
          }
          throw new Error(data.error);
        }).catch((error) => {
          error && setLoading({ update: false, listing: false });
        })
      }
    }
  })

  // const brandOption = async (brandValue: string) => {
  //   const data: _Object = await brandService.getBrands({ q: brandValue })
  //   return data.items?.map((item: _Object) => { return { label: item.name, value: item.id } })
  // }

  return (
    <>
      <Breadcrumbs
        trails={[
          {
            label: t('product.products'),
            path: `${routes.products}`
          },
          {
            label: t('supplier.suppliers'),
            path: `${routes.suppilers}`
          },
          {
            label: `${isEditMode ? t('supplier.update_supplier') : t('supplier.new_supplier')}`,
            path: ''
          }
        ]}
        pageTitle={`${isEditMode ? t('supplier.update_supplier') : t('supplier.new_supplier')}`}

      />

      <form className={`filters ${loading.edit === true ? 'is-loading' : ''}`} onSubmit={formik.handleSubmit}>
        <div className="row gap-3 gap-sm-0">
          <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
            <div className="card">
              <div className="card-header">
                <strong>
                  {t('supplier.general_information')}
                </strong>
              </div>
              <div className="card-body">
                <InputField
                  name="name"
                  label={t('common.name')}
                  required={true}
                  value={formik.values.name}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  error={formik?.touched.name && formik.errors.name}
                />

                <InputField
                  name="company_name"
                  label={t('supplier.company_name')}
                  onBlur={formik.handleBlur}
                  value={formik.values.company_name}
                  onChange={formik.handleChange}
                />

                <SelectField
                  menuPlacement="auto"
                  name="status"
                  label={t('common.status')}
                  required={true}
                  options={[
                    { label: t('common.active'), value: 'active' },
                    { label: t('Inactive'), value: 'inactive' },
                  ]}
                  value={{ value: formik.values.status }}
                  onChange={(e: _Object) => {
                    formik.setFieldValue('status', e?.value || '')
                  }}
                  getOptionLabel={(option: { [key: string]: string }) => option.label}
                  getOptionValue={(option: { [key: string]: string }) => option.value}
                  error={formik.touched.status && formik.errors.status}
                />

                <TextArea
                  rows={5}
                  name="description"
                  className="col-12"
                  label={t('common.description')}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  placeholder={t('common.enter_description')}
                  value={formik.values.description}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4 col-xl-4 col-xxl-4">
            <div className="card">
              <div className="card-header">
                <strong>{t('supplier.contact_information')}</strong>
              </div>
              <div className="card-body">
                {/* <InputField
                  type="number"
                  name="phone_number"
                  label={t('supplier.contact_number')}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone_number}
                  // onChange={formik.handleChange}
                  onChange={(e: any) => {
                    const inputValue = e.target.value;
                    const numericValue = inputValue.replace(/\D/g, '');  // Remove non-numeric characters
                    const trimmedValue = numericValue.slice(0, 10);  // Keep only the first 10 digits
                    formik.setFieldValue('phone_number', trimmedValue);
                  }}
                /> */}

                <InputField
                  type="email"
                  name="email"
                  label={t('common.email')}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />

                <InputField
                  type="number"
                  name="mobile_number"
                  label={t('common.mobile_number')}
                  onBlur={formik.handleBlur}
                  value={formik.values.mobile_number}
                  // onChange={formik.handleChange}
                  onChange={(e: any) => {
                    const inputValue = e.target.value;
                    const numericValue = inputValue.replace(/\D/g, '');  // Remove non-numeric characters
                    const trimmedValue = numericValue.slice(0, 10);  // Keep only the first 10 digits
                    formik.setFieldValue('mobile_number', trimmedValue);
                  }}
                />
              </div>
            </div>

            {/* <div className="card">
              <div className="card-header">
                <strong>
                  {t('supplier.brands')}
                </strong>
              </div>
              <div className="card-body">
                <AsyncSelectField
                  menuPlacement="auto"
                  isMulti
                  isClearable
                  cacheOptions
                  label={t('supplier.brands')}
                  placeholder={t('common.choose_option')}
                  name="brand_ids"
                  loadOptions={brandOption}
                  ref={(ref: any) => (selectAsyncSelect.current = ref)}
                  defaultOptions={brands?.map((item: _Object) => { return { label: item?.name, value: item?.id } })}
                  onChange={(val: _Object) => {
                    formik.setFieldValue('brand_ids', val.map((item: _Object) => item?.value))
                    formik.setFieldValue('brand_list', val)
                  }}
                  value={
                    formik.values.brand_list?.map((item: _Object) => {
                      return {
                        label: item?.name || item?.label,
                        value: item?.id || item?.value
                      }
                    })
                  }
                />
              </div>
            </div> */}
          </div>

          <div className="col col-md-6 col-lg-4 col-xl-4 col-xxl-4">
            <div className="card">
              <div className="card-header">
                <strong>{t('common.address')}</strong>
              </div>
              <div className="card-body">
                <div className="row">
                  <InputField
                    name="address1"
                    label={`${t('common.address')} 1`}
                    onBlur={formik.handleBlur}
                    value={formik.values.address1}
                    onChange={formik.handleChange}
                  />

                  <InputField
                    name="address2"
                    label={`${t('common.address')} 2`}
                    onBlur={formik.handleBlur}
                    value={formik.values.address2}
                    onChange={formik.handleChange}
                  />

                  <InputField
                    className="col-6"
                    name="city"
                    label={t('common.city')}
                    onBlur={formik.handleBlur}
                    value={formik.values.city}
                    onChange={formik.handleChange}
                  />

                  <InputField
                    className="col-6"
                    // type="number"
                    name="postcode"
                    label={t('common.postCode')}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.postcode}
                  />

                  <SelectField
                    className="col-6"
                    name="country"
                    label={t('common.country')}
                    options={countries}
                    value={{ value: formik.values.country || 'IN' }}
                    onChange={(e: _Object) => {
                      formik.setFieldValue('country', e?.value || '')
                    }}
                  />

                  <SelectField
                    className="col-6"
                    name="province"
                    label={t('common.state')}
                    options={countries?.find((obj: _Object) => obj.value === (formik?.values?.country?.length > 0 ? formik?.values?.country : 'IN'))?.states}
                    onChange={(e: _Object) => {
                      formik.setFieldValue('province', e?.label || '')
                    }}
                    value={{ label: formik.values.province }}
                    // disabled={!formik.values.country}
                    getOptionLabel={(option: { [key: string]: string }) => option?.label}
                    getOptionValue={(option: { [key: string]: string }) => option?.label}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="row my-3">
          <div className="col-12 d-flex">
            <Button type="submit" name={isEditMode ? t('common.update') : t('common.submit')} className="primary" loading={loading.update} />
            <LinkButton
              path={routes.suppilers}
              label={t('common.cancel')}
              className="link text-danger fw-medium text-decoration-underline" />
          </div>
        </footer>
      </form>
    </>
  )
}
export default CreateSupplier


{/* <InputField
  className="col-6"
  // type="number"
  name="province"
  label="Province"
  value={formik.values.province}
  onChange={formik.handleChange}
/> */}

{/* <SelectField
  menuPlacement="auto"
  className="col-6"
  name="country"
  label="Country"
  options={countryData()}
  // value={countryData().filter(obj => obj.name == formik.values.country)}
  value={{ name: formik.values.country || 'India' }}
  onChange={(data: _Object) => {
    formik.setFieldValue('country', data.name)
  }}
  getOptionLabel={(option: _Object) => option.name}
  getOptionValue={(option: _Object) => option.isoCode || option.name}
/> */}